import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { getFormValues, formValueSelector } from 'redux-form';
import { CATEGORY_FIELD } from '../BaseForm';
import { createOption } from '../CategorySelect';
import { CategoryType } from '../types';
import { getUserInfoForGQ } from '../../../selectors/user';
import { getQuestionsByCategoryKey } from '../../../selectors/questions';
import { fetchQuestions } from '../../../actions/questions';
import { postJob } from '../../../actions/getQuotes';
import Wizard from './Wizard';

const form = formValueSelector('GQWIZARD');
const last = arr => arr[arr.length - 1];
const flattenAnswers = a =>
  Array.isArray(a) ? a.map((e, i) => (e ? String(i) : null)).filter(Boolean) : [a];

// TODO this is shit, tests and refactor :)
const generateFlow = (questions = [], answers = [], { skipLocation, skipCategory }) => {
  const category = skipCategory ? [] : ['CATEGORIES'];
  const location = skipLocation ? [] : ['LOCATION'];
  const ending = ['DESCRIPTION', 'CONTACT'];

  const values = answers
    .map(a => a.value)
    .reduce((prev, current) => [...prev, ...flattenAnswers(current)], []);

  const questionPool = questions.filter(
    q => q.relatedAnswer === null || values.includes(String(q.relatedAnswer))
  );

  const standardQuestions = questionPool.filter(q => q.relatedAnswer === null).map(q => ({
    ...q,
    next: q.answers
      .map(
        a =>
          values.includes(String(a.id)) ? questionPool.find(q => q.relatedAnswer === a.id) : null
      )
      .filter(Boolean)
  }));

  const flattenedQuestions = standardQuestions.reduce(
    (prev, current) => [...prev, current, ...current.next],
    []
  );
  return [
    ...category,
    ...location,
    'STARTBY',
    ...flattenedQuestions.map(q => `GQQUESTION:${q.id}`),
    ...ending
  ];
};

const getFirstStep = (cat, loc) => {
  if (cat === undefined) {
    return ['CATEGORIES'];
  }
  if (loc === undefined) {
    return ['LOCATION'];
  }
  return ['STARTBY'];
};

export class StateProvider extends Component {
  static propTypes = {
    categories: PropTypes.arrayOf(CategoryType),
    category: CategoryType,
    questions: PropTypes.array,
    answers: PropTypes.array,
    fetchQuestions: PropTypes.func,
    initialLocation: PropTypes.string,
    initialCategory: PropTypes.object,
    user: PropTypes.object,
    close: PropTypes.func,
    postJob: PropTypes.func
  };

  state = {
    stack: getFirstStep(this.props.initialCategory, this.props.initialLocation)
  };

  componentDidMount() {
    const { initialCategory, fetchQuestions } = this.props;
    if (initialCategory) {
      fetchQuestions(initialCategory.seo_key);
    }
  }

  next = e => {
    e && e.preventDefault && e.preventDefault();
    const { stack } = this.state;
    const flow = generateFlow(this.props.questions, this.props.answers, {
      skipLocation: this.props.initialLocation,
      skipCategory: this.props.initialCategory
    });
    const currentIndex = flow.findIndex(s => s === last(stack));
    const nextStep = flow[currentIndex + 1];
    this.setState({ stack: [...stack, nextStep] });
  };

  back = e => {
    e && e.preventDefault && e.preventDefault();
    const { stack } = this.state;
    this.setState({ stack: stack.slice(0, -1) });
  };

  getProgress = () => {
    const step = last(this.state.stack);

    switch (step) {
      case 'CATEGORIES':
        return '0%';
      case 'LOCATION':
        return '20%';
      case 'STARTBY':
        return '40%';
      case 'DESCRIPTION':
        return '80%';
      case 'CONTACT':
        return '100%';
    }

    // for anything else, we need to calculate what the percentage should be since there are related questions to account for
    // this calculation makes up the range between 60-80% the magic number of 20 represents the gap between 80 and 60.
    const { answers, questions } = this.props;
    const percentage = answers.length / questions.length;
    const progress = 60 + 20 * percentage;

    return `${progress}%`;
  };

  render() {
    const {
      fetchQuestions,
      questions,
      answers,
      close,
      postJob,
      initialLocation,
      initialCategory,
      ...rest
    } = this.props;
    return (
      <Wizard
        close={close}
        next={this.next}
        back={this.back}
        step={last(this.state.stack)}
        questions={questions}
        postJob={values => {
          if (initialLocation) {
            values.w = initialLocation;
          }
          if (initialCategory) {
            values[CATEGORY_FIELD] = initialCategory ? createOption(initialCategory) : undefined;
          }
          postJob(values);
        }}
        answers={answers}
        progress={this.getProgress()}
        onSelectCategory={option => option.seo_key && fetchQuestions(option.seo_key)}
        {...rest}
      />
    );
  }
}
const ConnectedForm = connect(
  (state, props) => {
    const categories = form(state, [CATEGORY_FIELD], 'drilldown_categories');
    const answers = Object.keys(getFormValues('GQWIZARD')(state) || {})
      .filter(q => q.includes('get_quotes_question_'))
      .map(k => ({ key: k, value: form(state, k) }));
    const category =
      props.initialCategory || categories.drilldown_categories || categories[CATEGORY_FIELD];
    return {
      answers,
      user: getUserInfoForGQ(state),
      selectedCategory: form(state, CATEGORY_FIELD),
      questions: props.disableQuestions
        ? []
        : getQuestionsByCategoryKey(state, category && category.seo_key)
    };
  },
  { fetchQuestions, postJob }
)(StateProvider);

ConnectedForm.propTypes = {
  categories: PropTypes.arrayOf(CategoryType),
  fetchQuestions: PropTypes.func
};

export default ConnectedForm;
